/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import deepEqual from "deep-equal";

class SaveManager {
  constructor(store) {
    this.store = store;
    this.dispatch = store.dispatch;
    this.getState = store.getState;
    this.timer = null;
    this.lastKnowPage = null;
    this.enabled = false;
  }

  enable() {
    this.enabled = true;
    this.startTimer();
  }

  packComponents(components) {
    return components.map(cmp => {
      const { components, ...rest } = cmp;
      return rest;
    });
  }

  savePage() {
    const { page } = this.store.getState();
    const { page_content, components } = page;
    if (!this.lastKnowPage) {
      this.lastKnowPage = components;
      return;
    }

    if (!deepEqual(components, this.lastKnowPage)) {
      this.dispatch({
        type: "SAVE_PAGE",
        fn: ({ error, data }) => {
          if (data) {
            const { components, ...rest } = data.page_content;
            this.dispatch({ type: "SET_PAGE_CONTENT", payload: rest });
          }
          this.lastKnowPage = page.components;
          if (!error) {
            this.dispatch({ type: "SAVE_PAGE_END" });
          }
        },
        values: {
          url: `/custom-page/page_contents/${page.id}/${page_content._id}`,
          params: {
            page_content: {
              ...page_content,
              components: this.packComponents(components)
            }
          }
        }
      });
    }
  }

  startTimer() {
    clearInterval(this.timer);
    this.timer = setInterval(this.savePage.bind(this), 3000);
  }

  stopTimer() {
    clearInterval(this.timer);
  }

  resetTimer() {
    this.startTimer();
  }
}

export default SaveManager;
